// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"containersidebar_wrapper__YPE1b"};